import { Icon } from "armstrong-react";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import * as StringUtil from "@travellocal/utils/stringHelpers";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface IRegionGalleryComponentProps extends React.Props<RegionGalleryComponent> {
  region: IState<IRegion>;
  imageClicked: (regionSlug: string, fileName: string) => void;
}

export class RegionGalleryComponent extends React.Component<IRegionGalleryComponentProps, {}> {
  private imageClicked(regionSlug: string, fileName: string): void {
    GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Open Gallery");
    this.props.imageClicked(regionSlug, fileName);
  }
  render() {
    const region = this.props.region.data;
    return (
      <div className="width-wrapper p-top-medium p-bottom-medium region-gallery">
        <Helmet
          title={region.galleryPageTitleTag}
          meta={[
            { name: "description", content: region.galleryPageDescriptionTag },
          ]}
          link={[
            { rel: "canonical", href: `${globalConfig.wwwBaseUrl}${WebRoutes.regionGallery(region.slug)}` },
          ]}
        />

        {this.props.children}

        <p className="info-box"><Icon icon={Icon.Icomoon.info2} /> Click or tap on an image to see it fullscreen</p>

        <div className="gallery">
          {(region.images || [])
            .filter(x => !x.locationImageType)
            .map(image => (
              <div key={`country-image-${image.id}`}>
                <img
                  src={image.thumbnailUrl}
                  alt={image.meta}
                  title={StringUtil.truncate(image.description, 75)}
                  onClick={() => this.imageClicked(region.slug, image.fileName)} />
              </div>
            ))}
        </div>

      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    imageClicked: (countrySlug: string, fileName: string) =>
      dispatch(push(WebRoutes.regionGalleryImage(countrySlug, fileName))),
  };
};

const mapStateToProps = (state: IWebStoreState) => {
  return {
    region: state.region,
  };
};

export const RegionGallery = connect(mapStateToProps, mapDispatchToProps)(RegionGalleryComponent);
